import { makeStyles } from "@mui/styles";

const drawerWidth = 250;
// const headerHeight = 65;
// const newWidth = 400;
export const layoutStyle = makeStyles((theme) => {
  return {
    appBar: {
      width: `calc(100% - ${drawerWidth + 20}px)!important`,
      // width: "calc(100% - 318px) !important",
      marginLeft: drawerWidth + 20,
      transition:
        "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
      flexDirection: "column !important",
      boxSizing: "border-box !important",
      flexShrink: 0,
      position: "relative",
      zIndex: 1100,
      left: "auto",
      right: "0px !important",
      boxShadow: "none !important",
      backdropFilter: "none !important",
      color: "#9BA323 !important",
      top: "0px",
      minHeight: "4.6875rem",
      display: "grid !important",
      alignItems: "center",
      borderRadius: "0.75rem",
      padding: "0.5rem 0.5rem 0.5rem 1rem",
      backgroundColor: "transparent !important",
      "&::after": {
        transition: "box-shadow 300ms cubic- bezier(0.4, 0, 0.2, 1) 0ms",
        flexDirection: "column",
        width: "100 %",
        boxSizing: "border-box",
        flexShrink: "0",
        position: "sticky",
        zIndex: "1100",
        left: "auto",
        right: "0px",
        boxhadow:
          "rgb(255 255 255 / 90 %) 0rem 0rem 0.0625rem 0.0625rem inset, rgb(0 0 0 / 5 %) 0rem 1.25rem 1.6875rem 0rem",
        backdropFilter: "saturate(200 %) blur(1.975rem)",
        backgroundColor: "#9BA323 !important",
        color: "rgb(52, 71, 103)",
        top: "0.75rem",
        minHeight: "4.6875rem",
        display: "grid",
        webkitBoxAlign: "center",
        alignItems: "center",
        borderRadius: "0.75rem",
        padding: "0.5rem 0px",
      },
    },
    appBarShift: {
      //   [theme.breakpoints.down("md")]: {
      //     width: "calc(100% - 24px) !important",
      //     right: "12px !important",
      //   },
      //   width: "calc(100% - 261px) !important",
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      flexDirection: "column !important",
      boxSizing: "border-box !important",
      flexShrink: 0,
      position: "fixed",
      zIndex: 1100,
      left: "auto !important",
      right: "-6px !important",
      boxShadow: "none !important",
      // boxShadow:
      //   "rgb(255 255 255 / 90%) 0rem 0rem 0.0625rem 0.0625rem inset, rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem !important",
      // backdropFilter: "saturate(200%) blur(1.875rem) !important",
      color: "white !important",
      top: "-10px !important",
      minHeight: "4.6875rem !important",
      display: "grid !important",
      alignItems: "center",
      // borderRadius: "0.75rem",
      padding: "0.5rem 0.5rem 0.5rem 1rem",
      // backgroundColor: "transparent !important",

      marginTop: 10,
      marginRight: 6,
      [theme.breakpoints.up("md")]: {
        width: `calc(100% - ${drawerWidth}) !important`,
        marginLeft: drawerWidth + 30,
      },
    },
    footerShift: {
      //   [theme.breakpoints.down("md")]: {
      //     width: "calc(100% - 24px) !important",
      //     right: "12px !important",
      //   },
      //   width: "calc(100% - 261px) !important",
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      flexDirection: "column !important",
      boxSizing: "border-box !important",
      flexShrink: 0,
      position: "fixed",
      zIndex: 1100,
      left: "auto !important",
      right: "-6px !important",
      boxShadow: "none !important",
      // boxShadow:
      //   "rgb(255 255 255 / 90%) 0rem 0rem 0.0625rem 0.0625rem inset, rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem !important",
      // backdropFilter: "saturate(200%) blur(1.875rem) !important",
      color: "white !important",
      minHeight: "4.6875rem !important",
      display: "grid !important",
      alignItems: "center",
      // borderRadius: "0.75rem",
      padding: "0.5rem 0.5rem 0.5rem 1rem",
      // backgroundColor: "transparent !important",
      backgroundColor: "var(--surface) !important",
      marginTop: 30,
      marginRight: 6,
      [theme.breakpoints.up("md")]: {
        width: `calc(100% - ${drawerWidth}) !important`,
        marginLeft: drawerWidth + 30,
      },
    },
    drawerPaper: {
      // width: "15.625rem",
      flex: "0 0 auto",
      whiteSpace: "nowrap",
      border: "none",

      //   "& .css-4t3x6l-MuiPaper-root-MuiDrawer-paper": {
      //     marginTop: "100px !important",
      //   },
      "& .MuiDrawer-paper": {
        boxShadow: "rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem inherit",
        transform: "translateX(0px)",
        transition:
          "width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, background-color 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        // left: 0,
        marginBottom: "inherit",
        width: "calc(285px - 30px) !important",
        // background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))",
        // background: "linear-gradient(222deg, rgb(57, 57, 88), rgb(35, 38, 50))",
        backgroundColor: theme.palette.background.paper,
        border: "none",
        color: "rgba(0, 0, 0, 0.87)",
        overflowY: "hidden",
        display: "flex",
        flexDirection: "column",
        flex: "1 0 auto",
        zIndex: 1200,
        position: "fixed",
        top: 15,
        outline: "0px",
        fontSize: "22px !important",
        left: "-14px",
        padding: "1px 0px 1px 0px",
        height: "calc(100vh - 70px)",
        // borderRadius: "0.75rem !important",
        margin: "0em 0em",
        // padding: "0em 10px",
        // marginTop: "64px !important",
      },
    },
    box: {
      padding: "0px 0px ",
      textAlign: "center",
      opacity: 1,
      background: theme.palette.mode === "dark" ? theme.palette.background.paper : "var(--bg-page)",
      color: theme.palette.text.primary,
      boxShadow: "none",
      cursor: "pointer",
      height: "90%",
      borderRight: "solid",
      borderColor: "var(--divider) !important",
      borderWidth: "2px",
      fontSize: "22px !important",
      "& .css-cveggr-MuiListItemIcon-root": {
        color: theme.palette.text.secondary,
      },
      "& .css-10hburv-MuiTypography-root": {
        fontSize: "12px !important",
      },
    },
    divider: {
      flexShrink: 0,
      borderTop: "0px solid rgba(0, 0, 0, 0.08)",
      borderRight: "0px solid rgba(0, 0, 0, 0.08)",
      borderLeft: "0px solid rgba(0, 0, 0, 0.08)",
      height: "0.0625rem",
      margin: "1rem 0px",
      borderBottom: "none",
      opacity: 0.25,
      backgroundColor: "transparent",
      backgroundImage:
        "linear-gradient(to right, rgba(255, 255, 255, 0), rgb(255, 255, 255), rgba(255, 255, 255, 0)) !important",
    },
    mainContent: {
      // height: `calc(100vh - ${headerHeight}px)`,
      // width: `calc(100% - ${newWidth + 40}px)`,
      // marginLeft: newWidth + 30,
      // marginTop: 200,
      // backgroundColor: "red",
      height: `calc(100vh - 121px)`,
      marginTop: "48px",
      marginLeft: "calc(var(--sidebar-width) + 20px)",
      padding: 12,
      paddingLeft: 8,
      background: "transparent !important",
      transition: "margin-left 0.3s ease",
    },
    mainFleetContent: {
      // height: `calc(100vh - ${headerHeight}px)`,
      // width: `calc(100% - ${newWidth + 40}px)`,
      // marginLeft: newWidth + 30,
      // marginTop: 200,
      // backgroundColor: "red",
      height: `calc(100vh - 160px)`,
      marginTop: "48px",
      marginLeft: "calc(var(--sidebar-width) + 20px)",
      padding: 12,
      paddingLeft: 8,
      background: "transparent !important",
      overflowX: "auto",
      transition: "margin-left 0.3s ease",
    },
    dashboardMainContent: {
      height: "fit-content",
      marginTop: "48px",
      marginLeft: "calc(var(--sidebar-width) + 20px)",
      padding: 12,
      paddingLeft: 8,
      background: "transparent !important",
      transition: "margin-left 0.3s ease",
      // backgroundRepeat: "no-repeat",
      // backgroundImage: `url(${dashboard})`,
      // backgroundRepeat: "no-repeat",
      // backgroundSize: "cover",
      marginBottom: "70px !important"
    },
    backgroundVideo: {
      width: "100%",
      position: "absolute",
      objectFit: "cover",
      transitionTimingFunction: "ease",
      backgroundImage: "Black",
      zIndex: "-111",
    },
    backgroundImage: {
      backgroundImage: `url("/bg-dashboard.jpg")`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "100vh",
      position: "relative",
    },
    mainContentCompany: {
      // height: `calc(100vh - ${headerHeight}px)`,
      // width: `calc(100% - ${newWidth + 40}px)`,
      // marginLeft: newWidth + 30,
      // marginTop: 200,
      // backgroundColor: "red",
      height: `calc(100vh - 215px)`,
      marginTop: "65px",
      marginLeft: "calc(var(--sidebar-width) + 20px)",
      padding: 20,
      paddingLeft: 5,
      background: "transparent !important",
      transition: "margin-left 0.3s ease",
    },
    gridContant: {
      height: `calc(100vh - 180px)`,
      marginTop: "10px",
      fontSize: "12px !important",
    },
    dashButton: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "var(--text-secondary) !important",
      borderColor: "var(--divider) !important",
    },
    mailColor: {
      color: "var(--state-danger)",
    },
    headerIcon: {
      "&.css-1guk29": {
        color: "var(--text-primary)",
      },
    },
    uploadButton: {
      // marginBottom: "5px",
      display: "flex",
      justifyContent: "end",
      alignItems: "center"
    },
    importCsv: {
      marginBottom: "5px",
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      color: "var(--text-primary) !important",
      background: "var(--bg-page) !important",
      marginLeft: "2px !important",
    },
    gridChart: {
      marginTop: 20,
    },
    chartLabel: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "10px",
      fontWeight: 700,
      color: "var(--text-primary)",
    },
    fleetListButton: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "var(--text-primary) !important",
      borderColor: "var(--divider) !important",
      background: "var(--bg-page) !important",
    },
    fleetListNewButton: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "var(--surface) !important",
      borderColor: "var(--brand-primary) !important",
      background: "var(--brand-primary) !important",
      borderRadius: "10px !important",
      textTransform: "none !important",
      transition: "all 0.2s ease !important",
      "&:hover": {
        transform: "translateY(-1px)",
        boxShadow: "0 4px 12px rgba(8, 96, 211, 0.15)",
        background: "var(--brand-primary-hover) !important",
      }
    },
    replacementButtonPrimary: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "white !important",
      borderColor: "var(--state-success) !important",
      background: "var(--state-success) !important",
      borderRadius: "10px !important",
      textTransform: "none !important",
    },
    replacementButtonAction: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "var(--brand-primary) !important",
      borderColor: "var(--brand-primary) !important",
      background: "transparent !important",
      borderWidth: "1px !important",
      borderStyle: "solid !important",
      borderRadius: "10px !important",
      textTransform: "none !important",
    },
    replacementButtonSuccess: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "white !important",
      borderColor: "var(--brand-primary) !important",
      background: "var(--brand-primary) !important",
      borderRadius: "10px !important",
      textTransform: "none !important",
    },
    replacementButtonSecondary: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "var(--text-primary) !important",
      borderColor: "var(--divider) !important",
      background: "var(--bg-page) !important",
      borderRadius: "10px !important",
      textTransform: "none !important",
    },
    replacementButtonDanger: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "white !important",
      borderColor: "var(--state-danger) !important",
      background: "var(--state-danger) !important",
      borderRadius: "10px !important",
      textTransform: "none !important",
    },
    addEditGrid: {
      justifyContent: "end",
      display: "flex",
      alignItems: "center",
      marginBottom: "5px !important",
    },
    addFleetListButton: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "var(--brand-primary) !important",
      borderColor: "var(--brand-primary) !important",
      background: "transparent !important",
      height: "40px",
      borderRadius: "10px !important",
      textTransform: "none !important",
    },
    buttonReactive: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "white !important",
      borderColor: "var(--brand-primary) !important",
      background: "var(--brand-primary) !important",
      height: "20px !important",
    },
    fontSize12: {
      fontSize: "12px !important",
    },
    fontSize14: {
      fontSize: "14px !important",
    },
    svg: {
      userSelect: "none",
      width: "80px !important",
      height: "80px !important",
      overflow: "hidden",
      display: "inline-block",
      textAlign: "center",
      flexShrink: 0,
      // fontAize: "1.5rem",
    },
    bottomNav: {
      backgroundColor: "var(--surface) !important",
      borderTop: "1px solid var(--divider)",
    },
    footerNav: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      color: "var(--text-secondary)",
      fontSize: "12px",
      height: "100%",
    },
    urlDivFuelPrice: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "14px",
      margin: 10,
    },
    dealerAddButton: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "var(--brand-primary) !important",
      padding: 2,
      fontSize: 12,
      borderColor: "var(--brand-primary) !important",
      background: "transparent !important",
    },
    dealerAddButtonDiv: {
      // padding: "0px 0px",
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      width: "100%",
      marginBottom: "5px",
    },
    dealerAddDownload: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "12px !important",
    },
    dealerFilterIcon: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "12px",
    },
    dealerIconPadding: {
      paddingRight: 10,
    },
    gridContantDealer: {
      height: `calc(100vh - 220px)`,
      marginTop: "4px",
      fontSize: "12px !important",
    },
    gridContantFleetList: {
      height: `calc(100vh - 220px)`,
      marginTop: "6px",
      fontSize: "12px !important",
    },
    gridContantFleetListPage: {
      height: `calc(100vh - 250px)`,
      marginTop: "6px",
      fontSize: "12px !important",
    },
    companyHeader: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      marginBottom: "0px",
      marginTop: "0px",
      padding: "0px",
    },
    companyHeaderDealer: {
      display: "flex",
      alignItems: "center",
      marginBottom: "0px",
      marginTop: "0px",
      padding: "0px",
    },
    companyAddBtn: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "10px",
    },
    companyMain: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    },
    companyButtonGroup: {
      display: "flex",
      justifyContent: "space-between",
      gap: "5px",
      fontSize: "12px",
      maxHeight: "20px !important",
    },
    companySubButton: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      cursor: "pointer",
    },
    companyForm: {
      display: "flex",
      flexDirection: "column !important",
      gap: "25px",
      margin: 15,
      width: "30vw",
      marginY: 1,
      paddingX: 2,
    },
    compnayFormField: {
      display: "flex",
      flexDirection: "column  !important",
      gap: "5px",
    },

    buttonGroup: {
      fontSize: "12px !important",
    },
    cardImage: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    gridContantEconomy: {
      height: `calc(100vh - 220px)`,
      marginTop: "6px",
      fontSize: "12px !important",
    },
    MuiDataGrid: {
      styleOverrides: {
        sortIcon: {
          color: "red",
        },
      },
    },
    ModelForm: {
      width: "100% !important",
    },
    subMenuHover: {
      "&:hover": {
        color: "white !important",
      },
    },
    disFlexCenter: {
      display: "flex",
      justifyContent: "center !important",
      alignItems: "center",
    },
    dailogTitle: {
      m: 0,
      p: 2,
      justifyContent: "center",
      display: "flex",
      fontSize: 14,
      fontWeight: "bold",
      color: "var(--brand-primary)",
    },
    dailogTitleInput: {
      m: 0,
      p: 2,
      justifyContent: "left",
      display: "flex",
      fontSize: 14,
      width: "50%",
      marginRight: "10px",
      color: theme.palette.text.primary,
    },
    boxEnd: {
      display: "flex",
      justifyContent: "end",
    },
    deleteOkButton: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "#FFFFFF !important",
      borderColor: "var(--brand-primary) !important",
      background: "var(--brand-primary) !important",
      fontSize: "12px !important",
      borderRadius: "8px !important",
      textTransform: "none !important",
      "&:hover": {
        background: "var(--state-danger) !important",
        borderColor: "var(--state-danger) !important",
      },
    },
    deleteCancelButton: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "var(--text-primary) !important",
      fontSize: "12px !important",
      borderColor: "var(--divider) !important",
      background: "var(--surface) !important",
      borderRadius: "8px !important",
      textTransform: "none !important",
      "&:hover": {
        background: "var(--bg-page) !important",
      }
    },
    actionDialog: {
      display: "flex",
      width: "50%",
      margin: "0px auto",
      alignItems: "center",
      fontSize: "14px !important",
    },
    addFleetListButton: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "var(--brand-primary) !important",
      borderColor: "var(--brand-primary) !important",
      background: "transparent !important",
      height: "20px",
      borderRadius: "10px !important",
      textTransform: "none !important",
    },
    headerAnalysisReport: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "12px !important",
      padding: 5,
    },
    headerAnalysisName: {
      fontWeight: 600,
    },
    reportButton: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "white !important",
      borderColor: "var(--brand-primary) !important",
      background: "var(--brand-primary) !important",
      borderRadius: "8px !important",
      textTransform: "none !important",
    },
    headerNameText: {
      fontSize: "14px !important",
      fontWeight: 800,
      color: "var(--brand-primary) !important",
      letterSpacing: "0.02em",
      textTransform: "uppercase",
      display: "inline-flex",
      alignItems: "center",
      marginBottom: "6px",
      paddingBottom: "2px",
      paddingTop: "10px"
    },
    actionButtonDialog: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "12px !important",
      margin: 10,
    },
    addActionButton: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "#FFFFFF !important",
      borderColor: "var(--brand-primary) !important",
      background: "var(--brand-primary) !important",
      height: "30px",
      borderRadius: "10px !important",
      padding: "0 20px !important",
      boxShadow: "0 6px 16px rgba(8, 96, 211, 0.16) !important",
      "&:hover": {
        boxShadow: "0 8px 20px rgba(8, 96, 211, 0.2) !important",
        transform: "translateY(-1px)",
      },
    },
    textinput: {
      "& .MuiInputBase-root-MuiInput-root-MuiSelect-root": {
        padding: "0px !important",
        fontSize: "14px !important",
        color: "var(--brand-primary) !important",
      },
      "& .MuiInput-root": {
        padding: "0px !important",
        fontSize: "14px !important",
        color: "var(--brand-primary) !important",
      },
      "& .MuiInput-underline::after": {
        borderBottom: "2px solid var(--brand-primary) !important",
      },
      "& .MuiSelect-standard::after": {
        borderBottom: "2px solid var(--brand-primary) !important",
      },
      fontSize: "14px !important",
      color: "var(--brand-primary) !important",
    },
    dealerLogo: {
      position: "absolute",
      left: "45%",
      width: "100%",
    },
    notFoundMainDiv: {
      height: "calc(100vh - 121px)",
      padding: "20px",
      marginTop: "60px",
      marginLeft: "calc(var(--sidebar-width) + 20px)",
      paddingLeft: "5px",
      display: "flex",
      justifyContent: "center",
      width: "100vh",
      background: "transparent !important",
      transition: "margin-left 0.3s ease",
    },
    redbox: {
      height: "15px !important",
      width: "15px !important",
      background: "#F77479 !important",
      border: "1px solid gray !important",
    },
    yellowbox: {
      height: "15px !important",
      width: "15px !important",
      background: "#F4F5A2 !important",
      border: "1px solid gray !important",
      marginLeft: "10px",
    },
    noteContain: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    notediv: {
      display: "flex",
      justifyContent: "end",
      // marginTop: "15px",
      float: "right",
      width: "100%",
      alignItems: "center",
    },
    dealerTitle: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px !important",
      fontWeight: 600,
    },
    reportNameHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px !important",
      fontWeight: 600,
      width: "80%",
    },
    titleHeader: {
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      display: "flex",
    },
    dealerNameTitle: {
      fontSize: "14px !important",
    },
    reportHeader: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: "0px",
      marginTop: "0px",
      padding: "12px 16px",
      fontSize: 22,
      fontWeight: 700,
      color: "var(--text-primary)",
      backgroundColor: "var(--surface) !important",
      borderBottom: "1px solid var(--divider)",
      borderRadius: "12px 12px 0 0",
    },
    reportInnerDiv: {
      padding: "6px",
      backgroundColor: "var(--surface) !important",
      height: "100%",
    },
    reportDivThree: {
      borderRadius: "8px !important",
      backgroundColor: "var(--surface) !important",
      border: "1px solid var(--divider) !important",
      margin: "0px",
      width: "100%",
      overflow: "hidden",
      transition: "box-shadow 0.2s ease",
      boxShadow: theme.palette.mode === "dark"
        ? "0 2px 10px rgba(0,0,0,0.3)"
        : "0 2px 8px rgba(8,96,211,0.05)",
      "&:hover": {
        boxShadow: theme.palette.mode === "dark"
          ? "0 4px 18px rgba(56,189,248,0.15)"
          : "0 4px 14px rgba(8,96,211,0.12)",
      },
    },
    reportCardThree: {
      borderRadius: "0px !important",
      backgroundColor: "var(--bg-page) !important",
      border: "none",
      margin: "0px !important",
      height: "100%",
    },
    reportInnerDivTitle: {
      color: "var(--text-secondary)",
      fontSize: 11,
      fontWeight: 500,
      padding: "8px 10px 2px 10px",
      letterSpacing: "0.3px",
    },
    reportInnerDivTotal: {
      color: "var(--brand-primary)",
      fontSize: 22,
      fontWeight: 700,
      padding: "2px 10px 6px 10px",
    },
    reportInnerDivIcon: {
      color: "var(--brand-primary)",
      fontSize: 12,
      padding: 4,
      paddingTop: "0px",
      paddingBottom: "0px",
      opacity: 0.6,
    },
    reportInnerDivSecTotal: {
      color: "var(--brand-primary)",
      fontSize: 32,
      fontWeight: 700,
      padding: 5,
      paddingTop: 10,
      paddingBottom: 10,
      textAlign: "center",
    },
    reportInnerDivSecTitle: {
      color: "var(--text-secondary)",
      fontSize: 13,
      fontWeight: 500,
      padding: 5,
      paddingTop: 6,
      paddingBottom: 14,
      textAlign: "center",
    },
    reportMainDiv: {
      backgroundColor: "var(--surface) !important",
      border: "1px solid var(--divider)",
      borderRadius: "14px",
      marginTop: "0px",
      padding: 0,
      paddingLeft: 0,
      overflow: "hidden",
      boxShadow: theme.palette.mode === "dark"
        ? "0 4px 24px rgba(0,0,0,0.5)"
        : "0 4px 24px rgba(8,96,211,0.07)",
    },
    reportInnerDivSec: {
      padding: "6px",
      borderRadius: "8px !important",
      backgroundColor: "var(--surface) !important",
      height: "141px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    reportCardSec: {
      borderRadius: "8px !important",
      backgroundColor: "var(--bg-page) !important",
      margin: "0px !important",
      height: "100%",
      border: "none !important",
    },
    reportCardBorder: {
      borderRadius: "8px !important",
      border: "1px solid var(--divider) !important",
      backgroundColor: "var(--surface) !important",
      height: "100%",
      boxShadow: theme.palette.mode === "dark"
        ? "0 2px 12px rgba(0,0,0,0.3)"
        : "0 2px 8px rgba(8,96,211,0.05)",
    },
    cardChartHeader: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "0px",
      marginTop: "0px",
      padding: "10px 14px 6px 14px",
      fontSize: 13,
      fontWeight: 600,
      color: "var(--text-primary)",
      borderBottom: "1px solid var(--divider)",
    },
    marginTopOne: {
      marginTop: "8px !important",
      padding: "0 12px 12px 12px !important",
    },
    reportFleetMargin: {
      marginTop: "60px !important",
      marginLeft: "var(--sidebar-width) !important",
      transition: "margin-left 0.3s ease",
    },
    reportHeaderTitle: {
      display: "flex",
      justifyContent: "space-between !important",
      alignItems: "center",
      width: "100%",
      padding: "4px 8px",
    },
    companyReportLogo: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    reportDonutGrid: {
      padding: "4px",
    },
    actionDialogCommon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px !important",
      marginTop: "8px !important",
    },
    textinput: {
      "& .css-1x51dt5-MuiInputBase-input-MuiInput-input": {
        padding: "0px !important",
        fontSize: "12px !important",
        color: "var(--brand-primary) !important",
      },
      "& .css-cnfv5a-MuiInputBase-root-MuiInput-root::after": {
        borderBottom: "2px solid var(--brand-primary) !important",
      },
      width: 300,
      fontSize: "12px !important",
      color: "var(--brand-primary) !important",
    },
    logoutButton: {
      marginTop: "10px !important",
      padding: "10px !important",
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "var(--text-primary) !important",
      borderColor: "var(--divider) !important",
      background: "var(--surface) !important",
    },
    profileHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    },
    countReplacementYear: {
      display: "flex",
      alignItems: "center",
    },
    countReplacementYearSpan: {
      padding: "8px 10px",
      border: "1px solid rgba(56, 189, 248, 0.3)",
      marginRight: "4px",
      background: "rgba(56, 189, 248, 0.1)",
      color: "#0860d3",
      fontWeight: 600,
      borderRadius: "8px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(4px)",
    },
    companyReportLogo: {
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
    },
    footerVersion: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    footerVersionText: {},
    footerSupportText: {
      background: theme.palette.background.paper,
      color: theme.palette.text.primary,
      padding: "5px 25px",
      marginLeft: "20px",
      borderRadius: "8px",
    },
    footerVersionButton: {
      background: `${theme.palette.background.paper} !important`,
      color: `${theme.palette.text.primary} !important`,
      padding: "5px 15px !important",
      marginLeft: "12px !important",
      textTransform: "capitalize !important",
    },
    supportInput: {
      "& input": {
        padding: "20px !important",
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 10,
        backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.05)" : "#FFFFFF",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(160, 198, 232, 0.35)",
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#208DE9",
      },
    },
    exportPowerBIButton: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "var(--text-primary) !important",
      borderColor: "var(--divider) !important",
      background: "var(--surface) !important",
      height: "30px",
      borderRadius: "8px !important",
    },
    footerVersionDiv: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    widthFooterVersion: {
      width: "400px",
    },
    fetchingMakeModel: {
      width: "20px !important",
      height: "20px !important",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    speakToTextButton: {
      color: "var(--text-primary) !important",
      background: "var(--surface) !important",
      fontWeight: "bold !important",
      borderColor: "var(--divider) !important",
      marginRight: "10px !important",
      padding: "4px 10px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      borderRadius: "8px !important",
    },
    requireFieldValue: {
      color: "red",
      fontSize: "14px !important",
      textTransform: "capitalize",
    },
    requireFieldValueLast: {
      color: "red",
      fontSize: "14px !important",
      textTransform: "capitalize",
      marginRight: 5,
    },
    headerContentFleet: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    },
    columnRequired: {
      color: "red",
      fontSize: "12px !important",
      marginRight: 10,
    },
    helpDeskGridContant: {
      height: `calc(100vh - 240px)`,
      marginTop: "1px",
      fontSize: "12px !important",
    },
    headerUserQuery: {
      fontSize: "14px !important",
      fontWeight: 700,
      color: "var(--brand-primary) !important",
      padding: 10,
    },
    helpTextBox: {
      width: "90%",
    },
    commentTextBox: {
      width: "80%",
      border: "1px solid var(--divider) !important",
      borderRadius: 10,
      marginTop: 10,
      marginRight: "5px !important",
    },
    chatLeft: {
      textAlign: "left",
    },
    chatRight: {
      textAlign: "right",
    },
    EditImageButton: {
      cursor: "pointer",
      background: "var(--surface) !important",
      color: "var(--brand-primary) !important",
    },
    PreviewButton: {
      cursor: "pointer",
      background: "var(--surface) !important",
      color: "var(--brand-primary) !important",
      marginRight: "5px !important",
    },
    modelSelect: {
      color: "var(--text-primary) !important",
      "&:hover": {
        color: "var(--brand-primary) !important",
      },
    },
    closeModelOkBtn: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "var(--brand-primary) !important",
      borderColor: "var(--brand-primary) !important",
      background: "var(--surface) !important",
      borderRadius: "8px !important",
      "&:hover": {
        background: "var(--bg-page) !important",
      },
    },
    headerUserLogs: {
      fontSize: "14px !important",
      fontWeight: 700,
      color: "var(--brand-primary) !important",
      padding: 10,
    },
    chatQuestion: {
      float: "right",
      paddingRight: "10px !important",
      maxWidth: "75% !important",
      border: "1px solid var(--brand-primary)",
      borderRadius: "12px",
      padding: 10,
      marginRight: 2,
      background: "var(--brand-primary)",
      color: "white",
    },
    spanChatQue: {
      padding: 10,
      color: "white",
    },
    chatAnswer: {
      textAlign: "left",
      padding: 10,
      width: "75% !important",
      background: "var(--surface)",
      border: "1px solid var(--divider)",
      paddingRight: "10px !important",
      borderRadius: "12px",
      margin: "15px",
      clear: "right",
    },
    spanChatAns: {
      padding: 10,
      color: "var(--text-primary)",
      width: "auto",
      lineHeight: 2,
      // borderRadius: "10px",
      // border: "1px solid gray",
      // background: "green",
    },
    chatHeader: {
      padding: "10px",
      fontSize: "14px",
      fontWeight: 600,
    },
    chatForm: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
    },
    chatButton: {
      background: "var(--brand-primary) !important",
      padding: "10px 25px !important",
      color: "white !important",
      borderRadius: "10px",
    },
    loaderChat: {
      color: "white !important",
      padding: "10px 25px !important",
      borderRadius: "10px",
      background: "var(--brand-primary) !important",
    },
    dotYes: {
      border: "1px solid var(--divider) !important",
      background: "rgba(239, 68, 68, 0.15) !important",
      marginRight: "5px",
      padding: 2,
      color: "var(--text-primary)",
      borderRadius: "4px",
    },
    dotNo: {
      border: "1px solid var(--divider) !important",
      background: "rgba(34, 197, 94, 0.15) !important",
      marginRight: "5px",
      padding: 2,
      color: "var(--text-primary)",
      borderRadius: "4px",
    },
    newVersionButtonBox: {
      marginRight: 20,
    },
    WhatsNewersionName: {
      fontWeight: 600,
      color: "orange !important",
      fontSize: "14px !important",
      fontFamily: "'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important",
    },
    whatNewHeader: {
      padding: "0px 30px",
      height: "calc(100vh - 270px)",
      color: "var(--brand-primary) !important",
      fontFamily: "'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important",
    },
    whatNewHeaderTitle: {
      fontWeight: 600,
      marginBottom: 10,
      marginTop: 10,
      color: "var(--brand-primary) !important",
      fontFamily: "'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important",
    },
    newVersionButton: {
      background: "var(--brand-primary) !important",
      color: "white !important",
      border: "1px solid var(--brand-primary) !important",
      padding: "5px 20px !important",
      fontFamily: "'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important",
      textTransform: "capitalize !important",
      borderRadius: "8px !important",
    },
    whatsNewTitle: {
      background: "var(--brand-primary)",
      color: "white",
      marginBottom: "10px !important",
      fontFamily: "'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    descriptionNewVersion: {
      marginTop: "10px !important",
    },
    descriptionNewVersionYesNo: {
      paddingLeft: "10px !important",
      marginTop: "5px !important",
    },
    descriptionNewVersionAvailableModel: {
      marginBottom: "5px !important",
    },
    mainContentUserGuide: {
      height: `calc(100vh - 121px)`,
      marginTop: "60px",
      marginLeft: "calc(var(--sidebar-width) + 20px)",
      padding: "20px 5px",
      background: "transparent !important",
    },
    sortingFieldText: {
      fontSize: "12px !important",
      backgroundImage:
        "linear-gradient(319deg, #f88379 0%, #fd9600 37%, #ffb347 100%)",
      color: "black",
      fontFamily: "'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif",
      padding: 5,
      marginRight: 2,
      fontWeight: 600,
    },
    totalAnnualMileageText: {
      backgroundColor: "var(--brand-primary) !important",
      borderRadius: "4px",
      padding: "7px 5px",
      fontSize: "14px",
      fontWeight: 600,
      color: "white",
    },
    analysisDilogSaveButton: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "#FFFFFF !important",
      borderColor: "var(--brand-primary) !important",
      background: "var(--brand-primary) !important",
      fontSize: "12px !important",
      borderRadius: "8px !important",
      "&:hover": {
        background: "var(--state-success) !important",
        borderColor: "var(--state-success) !important",
      },
    },
    analysisDilogCancelButton: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "var(--brand-primary) !important",
      borderColor: "var(--divider) !important",
      background: "var(--surface) !important",
      fontSize: "12px !important",
      borderRadius: "8px !important",
      "&:hover": {
        background: "var(--bg-page) !important",
        borderColor: "var(--state-danger) !important",
      },
    },
  };
});
